const ENDPOINTS = {
  auth: 'auth/',
  getKeys: 'GetKeys',
  logout: 'Logout',
  login: {
    viaMC: 'loginViaMC',
    viaOTP: 'LoginEncV2',
    viaOTPRecaptcha: 'SendOTPEncV2',
  },
  renewToken: 'RenewToken',
  customerInfo: {
    root: 'CustomerInfo/',
    GetCustomerInfoLite: 'GetCustomerInfoLite',
    GetCurrentPackageDetails: 'GetCurrentPackageDetails',
    installment: 'Installments',
    getActiveService: 'GetActiveService',
    getSwitchOption: 'GetSwitchOption?msisdn=',
    setSwitchOption: 'SetSwitchOption?option=',
    getSwitchAllowedOption: 'GetAllowedSwitchOptions',
    getDeviceDetails: 'GetDeviceDetails',
    uploadPic: 'UploadUserPic',
    downloadPic: 'DownloadUserPicBase64',
    getMyNumbers: 'GetMyNumbers',
    switchToMyNumbers: 'SwitchToMyNumbers',
    switchMyNumbersWithoutPin: 'SwitchMyNumbersWithoutPin',
    getNotification: 'GetNotifications',
    markNotificationAsRead: 'MarkNotificationAsRead',
    getSMSAdvertisementStatus: 'GetSMSAdvertismentStatus',
    getNotificationAdvertisementStatus: 'GetNotificationAdvertismentStatus',
    setNotificationAdvertisementStatus: 'SetNotificationAdvertismentStatus',
    setSMSAdvertisementStatus: 'SetSMSAdvertismentStatus',
    sendFCMToken: 'RegisterFCMToken',
    getListOfBioDevices: 'GetListOfBioDevices',
    invalidateBiometric: 'InvalidateBiometric',
    getFixedLineCustomerInfo: 'GetFixedLineCustomerInfo',
    updateQuickAccess: 'UpdateQuickAccess',
    getQuickAccessPagesList: 'GetQuickAccessPagesList',
    getFixedLinePlanDetails: 'GetFixedLinePlanDetails',
    updateProfileSendPin: 'UpdateProfileSendPin',
    updateProfile: 'UpdateProfile',
    updateFixedLineCallDetailsFlag: 'UpdateFixedLineCallDetailsFlag',
    profileData: 'ProfileData',
    getEsimPDF: 'GetEsimPDF',
    getFixedLineSohoCustomerInfo: 'GetFixedLineSOHOCustomerInfo',
    getSOHOPlanDetails: 'GetSOHOPlanDetails',
    getAvailablePopup: 'GetAvailablePopup'
  },
  package: {
    root: 'Package/',
    available: 'GetEligiblePackages',
    packageDetails: 'GetPackageDetails?PackageCode=',
    executeCommand: 'ExecuteCommand',
    termsAndConditions: 'GetPackageTermsAndConditions?PackageType=',
  },
  offers: {
    root: 'Offers/',
    offerDetails: 'GetOfferDetails?offerId=',
    offerDetailsForCampaign: 'GetOfferDetails',
    getCampaignOfferGifts: 'GetCampaignOfferGifts',
    getOffers: 'GetOffers?option=',
    getCrossSelling: 'GetCrossSellingOffers?CatType=',
    getActiveNotificationOffer: 'GetActiveNotificationOffer',
    getAvailablePopup: 'GetAvailablePopup',
    subscribeCampaignOffer: 'SubscribeCampaignOffer',
    getFixedLineHotOffers: 'GetFixedLineHotOffers',
    subscribeFixedLineHotOffer: 'SubscribeFixedLineHotOffer',
    renewOffer: 'RenewOffer'
  },
  bundle: 'Usage/GetRemainingBalances',
  invoice: {
    root: 'Invoices/',
    lastInvoices: 'LastInvoices',
    getInvoiceDetails: 'GetInvoiceDetailsV2?InvoiceID=',
    getCorporateInvoices: 'GetCustomerInvoices',
    getLastTwoInvoices: 'GetLastTwoInvoices',
    getInvoicePDF: 'GetInvoicePDF',
    fixedlineGetBillPDF: 'FixedlineGetBillPDF',
    getCallsDetails: 'GetCallsDetails',
    fixedline: {
      root: 'fixedline/',
      getAccountInvoices: 'GetAccountInvoices',
      getInvoicePDF: 'GetInvoicePDF',
      getBillDetails: 'GetBillDetails',
    },
    getOpenFLInvoices: 'GetOpenFLInvoices',
    getInstallments: 'GetInstallments',
    getRemainingBalances: 'GetRemainingBalances',
    getLineInstallments: 'Installments',
    getDeviceDetails: 'GetDeviceDetails',
    getPreviousDebt: 'GetPreviousDebt',
    getActiveInstallmentWithWarranty: 'GetActiveInstallmentWithWarranty',
    getAvaliableShowroomsforWarranty: 'GetAvaliableShowroomsforWarranty',
    updateShowroomforWarranty: 'UpdateShowroomforWarranty',
    latestPaymentsForOthers:'LatestPaymentsForOthers'
  },
  payment: {
    root: 'Payment/',
    corporateJPRoot: 'JawwalPay/',
    getPaymentType: 'GetPaymnetTypes',
    createPayment: 'CreatePayment',
    createSwitchSession: 'CreateSwitchSession',
    confirmPayment: 'ConfirmPayment',
    cancelPayment: 'CancelPayment',
    JPMethod: 'JPInvoices',
    JPCallBack: 'JPInvoicesCallback',
    rechargeRoot: 'TopupTransfer/',
    createRechargePayment: 'TopUpViaSwitch',
    rechargeSwitchCallBack: 'SwtichTopUpCallback',
    JPRechargeMethod: 'TopUpViaJawwalPay',
    JPRechargeCallBack: 'JPTopUpCallback',
    createVisaRechargePayment: 'Recharge/CreateVisaRechargePayment',
    createVisaInvoicePayment: 'Invoice/CreateVisaInvoicePayment',
    cardManagement: {
      root: 'CardManagement/',
      getCards: 'GetCards',
      invalidateCard: 'InvalidateCard',
      add: 'AddV2',
    },
    recurringService: {
      root: 'RecurringService/',
      subscribe: 'Subscribe',
      verifyOtp: 'VerifyOtp',
      transactions: 'Transactions',
      notes: 'Notes',
      termsAndConditions: 'TermsAndConditions',
      subscriptions: 'Subscriptions',
      updateService: 'UpdateService',
    },
    wire: {
      allowedToUseWire: 'AllowedToUseWire',
      getExchangeRates: 'GetExchangeRates',
      getBanks: 'GetBanks',
      validateWire: 'ValidateWire',
      createWire: 'CreateWire',
      cancelWire: 'CancelWire',
      getReciept: 'GetReciept',
    },
    bundle: {
      root: 'Bundle/',
      getPaymnetTypes: 'GetPaymnetTypes',
      createVisaBundlePayment :'CreateVisaBundlePayment',
      createJawwalPayPayment:'CreateJawwalPayPayment',
      createDigitalPayment:'CreateDigitalPayment',
      confirmJawwalPayPayment:'ConfirmJawwalPayPayment',
      cancelJawwalPayPayment:'CancelJawwalPayPayment'
    },
    getPaymnetTypesV2:'GetPaymnetTypesV2',
    getPaymnetTypesV3:'GetPaymnetTypesV3',
    rechargePaymentMethods:'recharge/paymentmethods',
    directPay:'DirectPay',
    /** Logged-in JawwalPay recharge (backend builds Jawwal token + hash) */
    rechargeJawwalPay: {
      create: 'Recharge/CreateJawwalPayPaymentV2',
      confirm: 'Recharge/ConfirmJawwalPayPayment',
    },
    /** Logged-in JawwalPay invoice payment */
    invoiceJawwalPay: {
      create: 'Invoice/CreateJawwalPayPaymentV2',
      confirm: 'Invoice/ConfirmJawwalPayPayment',
    },
  },
  toPupTransfer: {
    root: 'TopupTransfer/',
    getRefillAmount: 'GetRefilAmount',
    getTransferBalanceOptions: 'GetTopupTransferOptions',
    getTransferBalanceTerms: 'GetBalanceTransferTermsAndConditions',
    sendTransferBalanceCode: 'SendTopUpPin',
    executeTransferBalance: 'ExecuteCommand',
    rechargeSwitchCallBack: 'SwitchTopupCallback',
  },
  bundleCat: {
    root: 'Bundles',
    executeCommand: '/ExecuteCommand',
    getBundleAndOffer: '/GetAccountBundlesByCatType',
    getTopServices: '/GetTopServices',
    getBundlesByCat: '/GetBundlesByCategory',
    getBundleByCatId: '/GetBundlesAndServicesByCategoryId',
    getServiceDetails: '/GetServiceDetails',
  },
  usage: {
    root: 'Usage',
    getBalanceDeductionHistory: '/GetBalanceDeductionHistory',
    getFixedLineRemainingMinutes: '/GetFixedLineRemainingMinutes',
  },
  myTransactions: {
    root: 'MyTransactions',
    transactionsTypes: '/TransactionsTypes',
    transactions: '/Transactions',
  },
  roaming: {
    root: 'Roaming',
    getCountries: '/GetCountriesV2',
    national: '/GetNationalRoamingBundlesV2',
    getCountryInfo: '/GetCountryBundlesV2',
    getInFlightInternetBrowsing: '/GetInFlightInternetBrowsing',
    subscribeInFlightInternetBrowsing: '/SubscribeInFlightInternetBrowsing'
  },
  mcn: {
    root: 'MCN/',
    isServiceActive: 'IsServiceActive',
    termsAndConditions: 'TermsAndConditions',
    addMcn: 'AddMcn',
    removeMcn: 'RemoveMcn',
  },
  microLoans: {
    root: 'MicroLoans/',
    checkEligibility: 'CheckEligibility',
    getMicroLoans: 'GetMicroLoans',
    purchaseMicroLoan: 'PurchaseMicroLoan',
    microLoansAmount: 'MicroLoansAmount',
    termsAndConditions: 'TermsAndConditions',
    eligibleAndCurrentLoans: 'EligibleAndCurrentLoans',
    purchase: 'Purchase',
    isAllowed: 'isAllowed',
  },

  extraServices: {
    root: 'ExtraServices/',
    checkMaddedhaEligibility: 'CheckMaddedhaEligibility',
    subscribeMaddedha: 'SubscribeMaddedha',
    checkSafeInternetEligibility: 'checkSafeInternetEligibility',
    subscribeSafeInternet: 'SubscribeSafeInternet',
    getExtraBundleDetails: 'GetExtraBundleDetails',
    cmbsms: 'CMBSMS',
    latestTransactions: 'LatestTransactions',
    cbmTermsAndConditions: 'CMBTermsAndConditions',
    maddedha: {
      root: 'Maddedha/',
      getBundles: 'GetBundles',
      subscribe: 'Subscribe',
      termsAndConditions: 'TC',
    },
    paltelBook: {
      root: 'PaltelBook/',
      enquiry: 'Enquiry',
      getDistricts: 'GetDistricts'
    },
    /** PUK inquiry — confirm path and request body field names with backend */
    pukInquiry: {
      root: 'PUK/',
      inquire: 'Enquiry',
    },
  },
  selectedNumber: {
    root: 'Faf/',
    addNumber: 'AddFafV2',
    replaceNumber: 'ReplaceFAFV2',
    showNumbersList: 'ShowFafNumbers',
    getListOfAllowedFafs: 'GetListOfAllowedFafs',
  },
  disconnect: {
    root: 'Disconnect/',
    disconnectReasons: 'DisconnectReasons',
    isCustomerAllowedToDisconnect: 'IsCustomerAllowedToDisconnect',
    disconnectTermsAndConditions: 'DisconnectTermsAndConditions',
  },
  reconnect: {
    root: 'Reconnect/',
    isCustomerAllowedToReconnect: 'IsCustomerAllowedToReconnect',
    reconnectTermsAndConditions: 'ReconnectTermsAndConditions',
    reconnectAfterBOTermsAndConditions: 'ReconnectAfterBOTermsAndConditions',
    reconnectAfterBO: 'ReconnectAfterBO',
    isCustomerAllowedToReconnectAfterBO: 'IsCustomerAllowedToReconnectAfterBO',
    fixedLine: {
      root: 'Fixedline/',
      isAllowed: 'IsAllowed',
      execute: 'Execute',
    },
  },
  staticContent: {
    root: 'ContentManagement/',
    getContent: 'GetContent',
    getAllShowRooms: 'GetAllShowRooms',
  },
  mixRefill: {
    root: 'MixRef/',
    getMixRefillOptions: 'MixRefillOptions',
    executeMixRefill: 'MixRefill',
  },
  stopInternet: {
    root: 'InternetStop/',
    isActive: 'IsInternetStopActive',
    activateStopInternet: 'ActivateInternetStoppage',
    deactivateStopInternet: 'DeactivateInternetStoppage',
    isEligible: 'IsEligible',
  },
  RefillVoucher: {
    root: 'RefillVoucher/',
    refillVoucher: 'RefillVoucher',
  },
  followUp: {
    root: 'Complaints/',
    addFollowUp: 'AddCase',
    getFollowUp: 'GetComplaints',
    getFollowUpArea: 'GetComplaintsAreas',
    getFollowUpType: 'GetComplaintsTypes',
    getCorporateFollowUp: 'GetHistory',
    getCorporateFollowUpType: 'GetTypes',
    getCorporateFollowUpArea: 'GetAreas',
    addCorporateFollowUp: 'CreateCase',
  },
  poll: {
    root: 'Poll/',
    getQuestions: 'GetQuestions',
    addPoll: 'AddPoll',
  },
  freeSMS: {
    root: 'SmsFree/',
    getFreeSMSCount: 'FreeSmsCount',
    sendFreeSMS: 'SendFreeSMS',
  },
  internetSettings: {
    root: 'InternetServices/',
    sendInternetSettings: 'SendInternetSettings',
  },
  corporateLogInfo: {
    root: 'Auth/',
    logIn: 'Login',
    forgetPass: 'ForgetPassword',
    renew: 'Renew',
  },
  corporateAccount: {
    root: 'CorporateAccount/',
    rootAccount: 'RootAccounts',
    subAccount: 'SubAccounts',
    subscribers: 'Subscribers',
    getMobilePackageDetails: 'GetMobilePackageDetails'
  },
  corporate: {
    root: 'Corporate/',
    package: 'Packages',
    paymentType: 'PaymentTypes',
  },
  subscriber: {
    root: 'Subscriber/',
    getNumberDetails: 'SubscriberDetailsV2',
    getSubscriberBlackLists: 'GetSubscriberBlackLists',
    removeFromBlackList: 'RemoveFromBlackList',
    getEsimPDF: 'GetEsimPDF',
  },
  services: {
    root: 'Services/',
    getCatBundle: 'GetCategoriesBundles',
    getServiceFiltration: 'GetServiceDescriptionAndFilters',
    executeCommand: 'ExecuteCommand',
    addBundle: 'AddBundleToList',
    createorder: 'CreateOrder',
    getOrderDetails: 'GetOrderDetails',
    getOrders: 'GetOrders',
    getAppleBundles: 'GetAppleBundles'
  },
  corporateMCN: {
    root: 'MCN/',
    addMCN: 'AddMCN',
  },
  corpDisconnect: {
    disconnectReason: 'DisconnectReason',
  },
  swipeSim: {
    root: 'SimSwap',
    getReasons: '/GetSimSwapModel',
    getEsimPdf: '/GetEsimPdf',
  },
  session: {
    root: 'SessionManagement/',
    addSessionData: 'AddSessionVariables',
    getSessionData: 'GetSessionVariables',
  },
  report: {
    root: 'Report/',
    getTypes: 'Types',
    generate: 'Generate',
    getTermsAndCondition: 'TermsAndConditions',
    getCycles: 'GetCycles',
    getAccountInvoices: 'getAccountInvoices'

  },
  corporateTransaction: {
    root: 'Transactions/',
    getTypes: 'Types',
    getRecords: 'Records',
  },
  recharge: {
    root: 'Recharge',
    createPayment: '/CreatePayment',
    createCardsPayment: '/CreateCardsPayment',
    confirmPayment: '/ConfirmPayment',
    cancelPayment: '/CancelPayment',
  },
  invoicePayment: {
    root: 'InvoicePayment',
    createPayment: '/CreatePayment',
    createCardsPayment: '/CreateCardsPayment',
    confirmPayment: '/ConfirmPayment',
    cancelPayment: '/CancelPayment',
  },
  cardspayment: {
    root: '/CardsPayment',
    createpayment: '/CreatePayment',
  },
  gifting: {
    root: 'Gifting',
    getRecommendedGifts: '/GetRecommendedGifts',
    sendGift: '/SendGift',
    termsAndConditions: '/TermsAndConditions',
    checkEligibility: '/CheckEligibility',
  },
  fixedLineServices: {
    root: 'FixedLineServices/',
    getAvailableUpgradeSpeeds: 'GetAvailableUpgradeSpeeds',
    upgradeSpeed: 'UpgradeSpeed',
    speedUpgradeTC: 'SpeedUpgradeTC',
    checkFiber: 'CheckFiber',
    getFiberMigrationOffers: 'GetFiberMigrationOffers',
    addOpportunity: 'AddOpportunity',
    getAvailableTimeSlots: 'GetAvailableTimeSlots',
    fiberMigrationTC: 'FiberMigrationTC',
    getServices: 'GetServices',
    executeCommand: 'ExecuteCommand',
    getReconnectionEligbleServices: 'GetReconnectionEligbleServices',
    reconnect: 'Reconnect',
    getChangeLocationData: 'GetChangeLocationData',
    changeNumber: 'ChangeNumber',
    getServiceDetails: 'GetServiceDetails',
    getExtraQuotaOffers: 'GetExtraQuotaOffers',
    lineEnquiry: 'LineEnquiry',
    changeLocationTC: 'ChangeLocationTC',
    changeLocation: 'ChangeLocation',
    getDistricts: 'GetDistricts',
    uber: {
      root: 'Uber/',
      callRequest: 'CallRequest',
      technicalLocation: 'TechnicalLocation',
      lineEnquiryHistory: 'LineEnquiryHistory',
    },
    troubleTicket: {
      root: 'TroubleTicket/',
      add: 'Add',
      types: 'Types'
    },
    trackOrders: 'TrackOrders',
    point: {
      root: 'Points/',
      getTransactions: 'GetTransactions',
      getOffers: 'GetOffers',
      redeem: 'Redeem',
    },
    superfast: {
      root: 'superfast/',
      getoffers: 'getoffers',
      addorder: 'addorder',
    },
    ict: {
      root: 'ict/',
      priceList: 'GetPriceLists',
      mainProducts: 'GetMainProducts',
      getSectionProducts: 'GetSectionProducts',
      getSubProducts: 'GetSubProducts',
      getProductDetails: 'GetProductDetails',
      getProductAttachments: 'GetProductAttachments',
      getAvailableTimeSlot: 'GetAvaiableTimeSlot',
      getServiceAccounts: 'GetServiceAccounts',
      getDistricts: 'GetDistricts',
      getLocalities: 'GetLocalities',
      getQuarters: 'GetQuarters',
      addServiceAccount: 'AddServiceAccount',
      addICTOrder: 'AddICTOrder',
      getIctOrders: 'GetIctOrders',
      getICTStatuses: 'GetICTStatuses',
    },
    getSOHOServices: 'GetSOHOServices',
    getWIFINetworks: 'GetWIFINetworks',
    getWIFIBandwidth: 'GetWIFIBandwidth',
    getNetworkDevices: 'GetNetworkDevices',
    hasNetworkDeviceConnected: 'HasNetworkDeviceConnected',
    blockNetworkDevice: 'BlockNetworkDevice',
    getDisabledWIFINetworks: 'GetDisabledWIFINetworks',
    getWIFIChannels: 'GetWIFIChannels',
    editNetworkSettings: 'EditNetworkSettings'

  },
  guest: {
    root: 'Guest/',
    newSubscription: {
      root: 'NewSubscription/',
      sendOTP: 'SendOTP',
      verifyOTP: 'VerifyOTP',
      getOffers: 'GetOffers',
      addOrder: 'AddOrder',
      validateCustomer: 'ValidateCustomer',
    },
    eKYC: {
      root: 'EKYC/',
      getIdDetails: 'GetIdDetails',
      liveness: 'liveness',
      validate: 'validate',
    },
    trackOrder: {
      root: 'TrackOrder/',
      types: 'types',
      details: 'TrackOrder/',
    },
    followUp: {
      root: 'FollowUp/',
      changeAddress: 'ChangeAddress',
      closeActivity: 'CloseActivity',
    },
    changeAddress: {
      root: 'GetChangeAddressData',
    },
    invoices:{
      root: 'Invoices/',
      invoicesEnquiry:'InvoicesEnquiry'
    }
  },
  fixedLine: {
    root: 'fixedline/',
    corporateAccount: {
      root: 'CorporateAccount/',
      getAccounts: 'GetAccounts',
      getLines: 'GetLines',
    },
    troubleTicket: {
      root: 'TroubleTicket/',
      getTypes: 'GetTypes',
      history: 'History',
      add: 'Add',
      getQuestionaire: 'GetQuestionaire',
      getServicesTypes: 'GetServicesTypes',
    },
    speedChange: {
      root: 'SpeedChange/',
      eligibleSpeeds: 'EligibleSpeeds',
      execute: 'Execute',
    },
    barring: {
      root: 'Barring/',
      getServices: 'GetServices',
    },
  },
  ramadan: {
    root: 'Ramadan/',
    isAllowedToSendBalance: 'IsAllowedToSendBalance',
    getAmount: 'GetAmount',
    termsAndConditions: 'TermsAndConditions',
    sendAmount: 'SendAmount',
    getGift: 'GetGift',
    subscibeGiftById: "SubscibeGiftById",
    getBundlesByCategory: 'GetBundlesByCategory',
    subscibeBundleById: 'SubscibeBundleById',
    getCampaignOffer: 'Campaign',
    getCampaignOpportunities: 'GetCampaignOpportunities',
    activateGift: 'ActivateGift'
  },
  directDebit: {
    root: 'DirectDebit/',
    loadBanks: 'LoadBanks',
    validateAccount: 'ValidateAccount',
    registerService: 'RegisterService',
    termsAndConditions: 'TermsAndConditions',
    isEligible: 'isEligible',
  },
  fiberSchedule: {
    root: 'FiberSchedule/',
  },
  groups: {
    getGroups: 'Group/GetGroups',
    createGroup: 'Group/Create',
    updateGroup: 'Group/Update',
    deleteGroup: 'Group/Delete',
    isEligibleFiberMigration: 'isEligibleFiberMigration',
    getAvaiableTimeSlot: 'GetAvaiableTimeSlot',
    addFiberMigrationOrderV2: 'AddFiberMigrationOrderV2',
    reserveSchedule: 'ReserveSchedule',
    fiberOffersAndAddOn: 'FiberOffersAndAddOn',
  },
  transactions: {
    root: 'Transactions/',
    fixedLineTypes: 'FixedLineTypes',
  },
  newGifting: {
    root: 'NewGifting/',
    checkEligibility: 'CheckEligibility',
  },
  newPlus:{
    root:'NewPlus/',
    isEligible:'IsEligible',
    getComboProducts:'GetComboProducts',
    subscribeComboProducts:'SubscribeComboProducts'
  },
  directPay: {
    root: 'DirectPay/',
    processPayment: 'ProcessPayment',
  }

}

export default ENDPOINTS
